/**
 * ComponentRegistry — zero-dependency singleton.
 *
 * Each component class self-registers on import by calling
 * ComponentRegistry.register({ type, displayNameKey, getDisplayName, events, actions }).
 *
 * ModeEdit and eventActions read from here so new components
 * expand the dropdowns without touching those files.
 */
const _registry = new Map();

export const ComponentRegistry = {
    /**
     * Register a component's dropdown metadata.
     * @param {object} meta
     * @param {string}   meta.type            - scene object type string (e.g. 'vraiAgent')
     * @param {string}   [meta.displayNameKey] - i18n key for the generic label
     * @param {Function} [meta.getDisplayName] - (obj) => string, per-instance display name
     * @param {Array}    [meta.events]         - [{ value, labelKey }, ...]
     * @param {Array}    [meta.actions]        - [{ value, labelKey }, ...] (excluding shared show/hide)
     */
    register(meta) {
        if (!meta?.type) return;
        _registry.set(meta.type, meta);
    },

    /** @param {string} type @returns {object|null} */
    get(type) {
        return _registry.get(type) || null;
    },

    /** @returns {object[]} */
    getAll() {
        return [..._registry.values()];
    },
};
